import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { HorseListScene } from 'scenes';

class HorseListContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        key: 'clinics',
        exec: (done, failure) => {
          API.get('clinics')
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'horses',
        exec: (done, failure) => {
          API.get('horses')
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <HorseListScene clinics={results.clinics} horses={results.horses} />
  }
}

export default HorseListContainer;
